import script from "./CertificationFeedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationFeedback.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationFeedback.vue?vue&type=style&index=0&id=38445632&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38445632"]])

export default __exports__